// ── Zod Validation Schemas ────────────────────────────────────
// Input validation for service-layer boundaries

import { z } from 'zod'

// ── Task schemas ──

export const taskFormSchema = z.object({
  title: z.string().min(1, 'Title is required').max(200, 'Title too long'),
  description: z.string().max(2000, 'Description too long').default(''),
  points: z.number().int().min(0).max(10000),
  spiceLevel: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)]),
  dueDate: z.string().nullable(),
  frequency: z.enum(['once', 'daily', 'weekly', 'monthly']),
  proofRequired: z.boolean(),
  relationshipId: z.string().uuid('Invalid relationship'),
  requiredItems: z.array(z.string().max(100)).max(20).default([]),
})

export type ValidatedTaskForm = z.infer<typeof taskFormSchema>

// ── Profile schemas ──

export const profileUpdateSchema = z.object({
  display_name: z.string().min(1).max(60).optional(),
  bio: z.string().max(500).optional(),
  pronouns: z.string().max(30).nullable().optional(),
  role: z.enum(['dom', 'sub', 'switch']).optional(),
  calendar_public: z.boolean().optional(),
  email: z.string().email().optional(),
})

export type ValidatedProfileUpdate = z.infer<typeof profileUpdateSchema>

// ── Relationship schemas ──

export const invitationSchema = z.object({
  currentUserId: z.string().min(1),
  targetEmail: z.string().email('Invalid email address').transform((e) => e.toLowerCase().trim()),
  currentUserRole: z.enum(['dom', 'sub']),
})

export type ValidatedInvitation = z.infer<typeof invitationSchema>
